import React, { ReactNode } from 'react';
import {
  AppRecoveryFallback,
  isChunkLoadError,
} from './appRecoveryFallback';

type Props = {
  children: ReactNode;
};

type State = {
  error: Error | null;
};

class LazyRouteErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      if (isChunkLoadError(error)) {
        return (
          <AppRecoveryFallback
            title="This page needs a refresh"
            message="A newer version of EndChess is available. Refresh the page to load it."
          />
        );
      }
      return <AppRecoveryFallback />;
    }
    return this.props.children;
  }
}

export default LazyRouteErrorBoundary;
